<template>
  <div class="app">
    <AppHeader fixed>
      <b-link class="home-link" to="/dashboard"
        ><font-awesome-icon :icon="['fas', 'home']" /></b-link
      >
      <b-link class="navbar-brand" to="/dashboard"
        ><img src="../assets/logo.png" alt=""></b-link
      >
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none">
          <user-info-header></user-info-header>
        </b-nav-item>
        <!--b-nav-item class="d-md-down-none notif-wrap">
          <font-awesome-icon :icon="['fas', 'bell']" />
          <span class="notif-pill"></span>
        </b-nav-item -->
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <Sidebar v-if="!isAdmin">
        <SidebarNav :navItems="sidebarMenu"></SidebarNav>
      </Sidebar>
      <main :class="!isAdmin ? 'main' : 'main-admin'">
        <div class="toaster">
          <div class="message">
            <transition name="fade">
              <messageNotif v-show="isShowMessage" :width="100" class="message-position"/>
            </transition>
          </div>
        </div>
        <div :class="!isAdmin ? 'container-fluid' : 'container'">
          <router-view></router-view>
          <router-view name="admin" v-if="isAdmin"></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import sidebarMenu from '../placeholder/sidebarMenu.js'
import AppHeader from '../components/layoutComponent/Header'
import SidebarNav from '../components/layoutComponent/SidebarNav'
import Sidebar from '../components/layoutComponent/Sidebar'
import UserInfoHeader from '../components/user/UserInfoHeader'
import messageNotif from '../components/messageComponent'
import { mapGetters } from 'vuex'
export default {
  name: 'DefaultContainer',
  components: {
    AppHeader,
    UserInfoHeader,
    SidebarNav,
    Sidebar,
    messageNotif
  },
  computed: mapGetters(['isShowMessage']),
  data () {
    return {
      sidebarMenu: sidebarMenu.items,
      isAdmin: ['ROLE_UTILISATEUR', 'ROLE_ADMIN'].includes(this.userRole())
    }
  },
  methods: {
    ...mapGetters(['userRole'])
  }
}
</script>

<style lang="scss">
.home-link {
  color: #fff;
  font-size: 25px;
  margin-right: 70px;
}
.navbar-brand {
  img {
    height: 25px;
  }
}

.toaster {
  position: fixed;
  z-index: 1010;
  right: 0;
  top: 125px;
  background: #fff;
  .message {
    position: fixed;
    right: 0px;
    top: 65px;
    z-index: 1000;
    .message-position {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/container/DefaultContainer.vue